// extracted by mini-css-extract-plugin
export default {"box":"styles_box__85AKh","wrapperInput":"styles_wrapperInput__eLQsI"};